// Aviso de una sola lectura para la pantalla de entrada (p. ej. tras cambiar la contraseña).
let pending: string | null = null;

export function setLoginNotice(text: string): void {
  pending = text;
}

export function takeLoginNotice(): string | null {
  const text = pending;
  pending = null;
  return text;
}
